import {GET_ATTACHMENTS_SUCCESS} from "../../../reducers/settingsReducer";


export const getAttachmentsSuccess = (attachments) =>{
    return {
        type: GET_ATTACHMENTS_SUCCESS,
        payload: {attachments}
    }
}